import * as ACTION from "./UpdateMasterHotelActionType";
import { notifyHotelMasterUpdated } from "../../../utils/utils";

const updateMasterHotelSuccess = () => {
  return {
    type: ACTION.UPDATE_MASTER_HOTEL,
    payload: "",
  };
};

export const updateMasterHotelActions = () => {
  return async function (dispatch) {
    notifyHotelMasterUpdated();
    dispatch(updateMasterHotelSuccess());
  }
};
